<template>
  <div class="bg-img-im">
    <div class="heading">
      <h2>
        JUMPSTART YOUR <br />
        ENGINEERING CAREER
      </h2>

      <a href="#im" class="btn ">
        Apply Now
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.bg-img-im{
  margin-top: 100px;
}
a {
  text-transform: capitalize;
  font-family: "Spartan";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #181c2d;
}

.heading h2 {
  text-align: center;
  text-transform: uppercase;
  font-family: "Open Sans";
  font-size: 60px;
  font-weight: 800;
  letter-spacing: 0px;
  line-height: 60px;
  color: white;
  padding-bottom: 50px;
}
.laptop-header h1 {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 180px;
  font-weight: 800;
  letter-spacing: 0px;
  line-height: 64px;
  color: #a2d6f9;
  margin-top: -20px;
  padding-bottom: 100px;
}
.btn {
  margin: auto;
  position: absolute;

  top: 80;
  left: 0;
  bottom: 80;
  right: 0;

  width: 100%;

  background-color: #ffffff;
  text-align: center;
  max-width: 300px;
  height: 60px;
  border-radius: 35px;
  opacity: 1;
  padding-top: 20px;
}

@media only screen and (min-width: 601px) and (max-width: 1100px) {
  .heading h2 {
    font-size: 60px;
    font-weight: 800;
    letter-spacing: -3px;
    line-height: 60px;
    color: white;
  }
  .laptop-header h1 {
    text-transform: uppercase;
    font-family: "Spartan";
    font-size: 80px;
    font-weight: 800;
    letter-spacing: 0px;
    line-height: 64px;
    color: #a2d6f9;
    margin-top: -px;
    padding-bottom: 30px;
  }
  .btn {
    margin: auto;
    position: absolute;

    top: 80;
    left: 0;
    bottom: 80;
    right: 0;
    width: 100%;
    text-align: center;
    max-width: 200px;
    height: 60px;
    border-radius: 0;
    border-radius: 35px;
  }
}
@media only screen and (max-width: 600px) {
  .container {
    padding: 65px 0 50px 0;
  }
  .heading h2 {
    font-size: 24px;
    font-weight: 800;
    letter-spacing: 0px;
    line-height: 24px;
    color: white;
  }
  .laptop-header h1 {
    font-size: 80px;
    font-weight: 800;
    letter-spacing: 0px;
    line-height: 64px;
    color: #a2d6f9;
    margin-top: -40px;
    padding-bottom: 30px;
  }
  .btn {
    margin: auto;
    top: 80;
    left: 0;
    bottom: 80;
    right: 0;
    width: 100%;
    text-align: center;
    max-width: 250px;
    height: 60px;
  }
}
</style>
